import React from 'react'
import PropTypes from 'prop-types'

import { Card, CardHeading, CardContent, CardFooter } from '@components/layout/Card'
import useModalVisibilityControls from '@hooks/useModalVisibilityControls'

import { LearnMoreModal } from './CalculationConfig.LearnMoreModal'
import {
  OverallCalculationStrategyLabels, getCalculationStrategy
} from './CalculationConfig.helpers'
import './calculation-config.scss'

const CalculationConfig = ({
  assets
}) => {
  const calculationStrategy = getCalculationStrategy(assets)
  const calculationStrategyLabelAbbreviated = OverallCalculationStrategyLabels[calculationStrategy].abbreviated
  const { modalVisible, openModal, closeModal } = useModalVisibilityControls()

  return (
    <Card className='calculation-config'>
      <CardHeading>
        <h5>Calculation Settings</h5>
      </CardHeading>
      <CardContent>
        <div className='calculation-config__labels'>
          <p>Draw strategy</p>
          <p>{calculationStrategyLabelAbbreviated}</p>
        </div>

        {<LearnMoreModal
           className={'calculation-config__learn-more-modal'}
           open={modalVisible}
           onClose={closeModal}
           calculationStrategy={calculationStrategy}/>}
      </CardContent>
      <CardFooter>
        <a onClick={openModal}>
          Learn more
        </a>
      </CardFooter>
    </Card>
  )
}

CalculationConfig.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.shape({
    allow_automated_income_calculation: PropTypes.bool.isRequired,
    asset_events: PropTypes.arrayOf(PropTypes.shape({
      payload: PropTypes.shape({
        metadata: PropTypes.shape({
          allowCalculationToExceedSpecifiedValue: PropTypes.bool.isRequired
        })
      })
    }))
  }))
}

export { CalculationConfig }
